import { useLazyQuery } from '@apollo/client';
import { useEffect, useMemo, useState } from 'react';
import { MEDIA_UPLOAD_OPTIONS } from '../graphql/Queries';

const useMediaUploadOptions = () => {
  const [modules, setModules] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [isOptionsLoading, setIsOptionsLoading] = useState(true);

  const [mediaUploadOptions] = useLazyQuery(MEDIA_UPLOAD_OPTIONS, {
    fetchPolicy: 'cache-first',
    onCompleted: (response) => {
      setModules(response?.mediaUploadOptions?.modules || []);
      setFileTypes(response?.mediaUploadOptions?.fileTypes || []);
      setIsOptionsLoading(false);
    },
    onError: () => setIsOptionsLoading(false),
  });

  useEffect(() => {
    mediaUploadOptions();
  }, []);

  const typeOptions = useMemo(
    () =>
      modules?.map((item) => ({ label: item?.label, value: item?.value })) ||
      [],
    [modules],
  );

  const getSubtypeOptions = (type) =>
    modules
      ?.find((item) => item?.value === type)
      ?.subtypes?.map((item) => ({ label: item?.label, value: item?.value })) ||
    [];

  const allSubtypeOptions = useMemo(() => {
    const seen = new Map();
    modules?.forEach((item) =>
      item?.subtypes?.forEach((subtype) => {
        if (!seen?.has(subtype?.value)) {
          seen?.set(subtype?.value, {
            label: subtype?.label,
            value: subtype?.value,
          });
        }
      }),
    );
    return [...seen.values()];
  }, [modules]);

  const fileTypeOptions = useMemo(
    () =>
      fileTypes?.map((item) => ({ label: item?.label, value: item?.value })) ||
      [],
    [fileTypes],
  );

  const labels = useMemo(() => {
    const typeLabels = {};
    const subtypeLabels = {};
    modules?.forEach((item) => {
      typeLabels[item?.value] = item?.label;
      item?.subtypes?.forEach((subtype) => {
        subtypeLabels[subtype?.value] = subtype?.label;
      });
    });
    const fileTypeLabels = {};
    fileTypes?.forEach((item) => {
      fileTypeLabels[item?.value] = item?.label;
    });
    return { typeLabels, subtypeLabels, fileTypeLabels };
  }, [modules, fileTypes]);

  return {
    isOptionsLoading,
    typeOptions,
    fileTypeOptions,
    allSubtypeOptions,
    getSubtypeOptions,
    ...labels,
  };
};

export default useMediaUploadOptions;
